import React, { Suspense, useEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import { useMediaQuery } from 'react-responsive';
import { IComponentPage } from 'routes';
import Breakpoints from 'themes/constants/breakpoints';
import useRoute from 'hooks/useRoute';
import HeaderMain from 'components/Header/main/HeaderMain';
import { Navbar } from 'components/Navbar/Navbar';
import Footer from 'components/Footer/Footer';
import Modal from 'components/Modal/Modal';
import AppBanner from 'components/AppBanner/AppBanner';
import Loader from 'components/Loader/Loader';
import Audio from 'components/Audio/Audio';
import {
  RootLayoutContainer,
  RootLayoutBody,
  RootLayoutSticky,
} from './RootLayoutStyles';

type IRootLayoutProps = IComponentPage;

function RootLayout(props: IRootLayoutProps) {
  const { route, location, history } = props;
  const { action: historyAction } = history;
  const { pathname } = location;

  const isLaptop = useMediaQuery({ query: `(${Breakpoints.LAPTOP})` });

  useEffect(() => {
    if (historyAction !== 'POP') {
      window.scrollTo(0, 0);
    }
  }, [historyAction]);

  const { matchedRoute } = useRoute({ pathname });

  const titlePath = matchedRoute?.route?.titlePath;
  const headerType = matchedRoute?.route?.headerType;
  const hideHeader = matchedRoute?.route?.hideHeader;
  const hideFooter = matchedRoute?.route?.hideFooter;
  const hideNavbar = matchedRoute?.route?.hideNavbar;
  const hideSearch = matchedRoute?.route?.hideSearch;
  const hideSearchMobile = matchedRoute?.route?.hideSearchMobile;
  const hideAudio = matchedRoute?.route?.hideAudio;
  const fixedHeightBase = matchedRoute?.route?.fixedHeight;
  const fixedHeightLaptop = !!matchedRoute?.route?.fixedHeightLaptop && isLaptop;
  const fixedHeight = fixedHeightBase || fixedHeightLaptop;

  const withSearch = !hideSearch && (isLaptop || !hideSearchMobile);

  return (
    <RootLayoutContainer fixedHeight={fixedHeight}>
      {hideHeader ? null : (
        <HeaderMain
          titlePath={titlePath}
          withSearch={withSearch}
          type={headerType}
        />
      )}
      <RootLayoutBody fixedHeight={fixedHeight}>
        <Suspense fallback={<Loader />}>
          {renderRoutes(route?.routes)}
        </Suspense>
      </RootLayoutBody>
      {hideFooter ? null : <Footer />}
      <RootLayoutSticky>
        <Audio hide={hideAudio} />
        {hideNavbar ? null : <Navbar />}
      </RootLayoutSticky>
      <Modal />
      <AppBanner />
    </RootLayoutContainer>
  );
}

export default RootLayout;
